import React, { useEffect, useState } from "react";
import ReactDatetime from "react-datetime";
import moment from "moment";
import { Calendar } from "lucide-react";
import "../../styles/footprint-datepicker.css";

export const DEFAULT_FORMAT = "MMM DD, YYYY";

const FootprintDatePicker = (props) => {
    const [open, setOpen] = useState(false);

    const {
        placeholder = "Select Date",
        defaultDate,
        timeFormat = false,
        minimumDate,
        maximumDate,
        disabled,
        inputProps,
        onChange = () => { },
        disableWeekends = false,
        enableSaturday = false,
        disableCalendarOpen = false,
        customIsValidDate,
    } = props;

    const [selectedDate, setSelectedDate] = useState(
        defaultDate ? moment(defaultDate) : null
    );

    useEffect(() => {
        // Update internal state if defaultDate changes from parent
        if (defaultDate) {
            setSelectedDate(moment(defaultDate));
        }
    }, [defaultDate]);
    return (
        <div className="relative w-full">
            <ReactDatetime
                key={`${minimumDate ? moment(minimumDate).format("YYYY-MM-DD") : "default"}-${enableSaturday ? "sat" : "nosat"}`}
                dateFormat="MMM DD, YYYY"
                className={`new-rdt footprint-datepicker  ${props.className || ""}`}
                style={{ width: "100%", zIndex: 50 }}
                onFocus={() => setOpen(undefined)}
                onBlur={() => setOpen(false)}
                // open={disableCalendarOpen ? false : open}
                closeOnSelect={true}
                value={selectedDate ? selectedDate.format(DEFAULT_FORMAT) : ""}
                closeOnClickOutside={true}
                inputProps={{
                    ...inputProps,
                    placeholder: placeholder || "Select Date",
                    readOnly: true,
                    onClick: (e) => {
                        if (inputProps?.onClick && disableCalendarOpen) {
                            inputProps.onClick(e);
                            setOpen(false);
                        } else {
                            setOpen(true);
                        }
                    },
                    style: {
                        // fontSize: "18px",
                        background: inputProps?.disabled ? "#dddddd" : "white",
                        textAlign: inputProps?.textAlign || "left",
                        backgroundColor: "white",
                        paddingRight: "40px",
                    },
                }}
                disabled={disabled}
                // viewDate={minimumDate ? moment(minimumDate).toDate() : moment().toDate()}
                initialViewDate={
                    minimumDate ? moment(minimumDate).toDate() : moment().toDate()
                }
                placeholder={placeholder}
                isValidDate={(current) => {
                    const isAfterMin = minimumDate
                        ? current.isSameOrAfter(moment(minimumDate), "day")
                        : true;
                    const isBeforeMax = maximumDate
                        ? current.isSameOrBefore(moment(maximumDate), "day")
                        : true;
                    const isSunday = current.day() === 0;
                    const isSaturday = current.day() === 6;
                    const weekendAllowed =
                        !disableWeekends ||
                        (!isSunday && (!isSaturday || enableSaturday));
                    const passesCustomRule = customIsValidDate
                        ? customIsValidDate(current)
                        : true;

                    return (
                        isAfterMin &&
                        isBeforeMax &&
                        weekendAllowed &&
                        passesCustomRule
                    );
                }}
                onChange={(date) => {
                    setOpen(false);
                    const mDate = moment(date);
                    setSelectedDate(mDate);
                    if (
                        props.holidaySelected &&
                        (moment(date).day() === 0 || moment(date).day() === 6)
                    ) {
                        props.holidaySelected(true);
                    } else {
                        onChange(moment(date).format(DEFAULT_FORMAT));
                    }
                }}
                readOnly={true}
                timeFormat={timeFormat}
                {...(disableCalendarOpen ? { open: false } : {})}
            />
            <Calendar
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black pointer-events-none"
                size={20}
            />
        </div>
    );
};

export default FootprintDatePicker;
